module.exports = __webpack_public_path__ + "img/milan_hero_card.8bd759b1.png";